import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from "api";
import { STATUS } from "utils/status";
import { DeliveredState } from '../../interfaces/interface';
import extraReducers from '../../extraReducers/deliveredFileExtraReducer';

const resolveUploadFile = (input: unknown): File | null => {
  if (input instanceof File) {
    return input;
  }

  if (input && typeof input === 'object') {
    const nestedFile = (input as { file?: unknown }).file;
    if (nestedFile instanceof File) {
      return nestedFile;
    }
  }

  return null;
};

const initialState: DeliveredState = {
  delivered: {
    count: undefined,
    results: []
  },
  createDeliveredStatus: STATUS.NOT_STARTED,
  createUploadDeliveredFileMessage: ""
};

export const createUploadDeliveredFile = createAsyncThunk(
  'task/mark/delivered/company/POST',
  async (payload: { id: string, selectedFile: File }, thunkAPI) => {
    try {
      const { id, selectedFile } = payload;
      const uploadFile = resolveUploadFile(selectedFile);
      if (!uploadFile) {
        return thunkAPI.rejectWithValue({ message: 'Invalid file payload' });
      }

      if (uploadFile.size <= 0) {
        return thunkAPI.rejectWithValue({ message: 'Uploaded file is empty' });
      }

      try {
        const formData = new FormData();
        formData.append('file', uploadFile);
        const response = await api.post(`task/mark/delivered/company/?project_id=${id}`, formData);
        return response.data;
      } catch (error: any) {
        return thunkAPI.rejectWithValue(error?.response?.data ?? { message: error?.message || 'No response received' });
      }
    } catch (error: any) {
      if (error.response) {
        const { status, data } = error.response;
        let errorMessage = `Request failed with status ${status}`;
        if (data && data.message) {
          errorMessage += `: ${data.message}`;

        }
        return thunkAPI.rejectWithValue({ message: errorMessage });
      } else if (error.request) {
        return thunkAPI.rejectWithValue({ message: 'No response received' });
      } else {
        return thunkAPI.rejectWithValue({ message: error.message });
      }
    }
  }
);

const MarkDelivereduploadSlice = createSlice({
  name: 'delivered',
  initialState,
  reducers: {
    setCreateDeliveredStatus(state, action) {
      state.createDeliveredStatus = action.payload
    },
  },
  extraReducers
});

export const { setCreateDeliveredStatus } = MarkDelivereduploadSlice.actions
export default MarkDelivereduploadSlice.reducer;


